import type { MapStoreBase } from '../..';

export const fontSize = 14;
export const padding = 10;
export const feetLengthLimit = 5280 / 2;

interface ConvertProps {
  store: MapStoreBase;
  line: { value: number; unit: string };
}

export function shouldConvertToMiles({ store, line }: ConvertProps) {
  if (
    ((store as any).inNewProjectMode || (store as any).inEditGeometryMode) &&
    line.unit === 'ft' &&
    line.value >= feetLengthLimit
  ) {
    return true;
  }

  return false;
}
